import { get, isNil } from "lodash";
import { GenderLabel, LayoffDiscountRequestStatus, LessonType, ProductType } from "@onair/repositories";
import slugify from "slugify";

export const sleep = (ms: number) => {
	return new Promise((resolve) => setTimeout(resolve, ms));
};

export const formatNumber = (num: string): string => {
	if (num === "") return "";
	const strNum = num.toString();
	return strNum.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};

export const getFirstDefinedValue = <T = any>(
	obj: any,
	paths: string[],
): T | undefined => {
	const definedPath = paths.find((path) => !isNil(get(obj, path)));
	return definedPath ? get(obj, definedPath) : undefined;
};

export const renderSmallNumber = (num: number) => {
	if (num < 10 && num > 0) {
		return `0${num}`;
	}
	return num;
};

export const stringifyField = (field: any) => {
	if (!field) return "[]";
	return Array.isArray(field) ? JSON.stringify(field) : field;
};

export const getGenderLabel = (gender: GenderLabel) => {
	switch (gender) {
		case GenderLabel.FEMALE:
			return "Nữ";
		case GenderLabel.MALE:
			return "Nam";
		case GenderLabel.OTHER:
			return "Khác";
		default:
			return "Không xác định";
	}
};

export const getLessonTypeLabel = (type: LessonType) => {
	switch (type) {
		case LessonType.PDF:
			return "PDF";
		case LessonType.TEXT:
			return "Văn bản";
		case LessonType.VIDEO:
			return "Video";
		default:
			return "Không xác định";
	}
};

export const getProductTypeLabel = (type: ProductType) => {
	switch (type) {
		case ProductType.ONLINE_COURSE:
			return "Khoá học";
		case ProductType.TICKET_TIER:
			return "Sự kiện";
		case ProductType.CALENDAR_FRAME:
		case ProductType.CALENDAR:
			return "Lịch trống";
		case ProductType.MEMBERSHIP_PRICE:
			return "Membership";
		case ProductType.COMBO:
			return "Combo";
		case ProductType.RESKILL_PRICE:
			return "Reskill";
		default:
			return "Không xác định";
	}
};

export const toNonAccentVietnamese = (str: string) => {
	return slugify(str, {
		locale: "vi",
	});
};

export const getBannerOnlineCourse = (coverImage: string) => {
	let banner: string = coverImage;

	try {
		banner = coverImage ? JSON.parse(coverImage)?.publicUrl : coverImage;
	} catch {
		//
	}

	return banner;
};

export const checkSessionPartnerAffiliate = (
	key: string,
	currentUserName: string,
) => {
	const partnerUserName = sessionStorage.getItem(key);
	if (partnerUserName) {
		return partnerUserName;
	}
	return null;
};

export const getLayoffDiscountRequestStatusLabel = (status: LayoffDiscountRequestStatus) => {
    switch (status) {
      case LayoffDiscountRequestStatus.PENDING:
        return 'Chờ duyệt';
      case LayoffDiscountRequestStatus.APPROVED:
        return 'Đã duyệt';
      case LayoffDiscountRequestStatus.REJECTED:
        return 'Từ chối';
      case LayoffDiscountRequestStatus.CANCELLED:
        return 'Đã hủy';
      default:
        return status;
    }
};

export const getLayoffDiscountRequestStatusColor = (status: LayoffDiscountRequestStatus) => {
    switch (status) {
      case LayoffDiscountRequestStatus.PENDING:
        return 'warning';
      case LayoffDiscountRequestStatus.APPROVED:
        return 'success';
      case LayoffDiscountRequestStatus.REJECTED:
        return 'error';
      case LayoffDiscountRequestStatus.CANCELLED:
        return 'default';
      default:
        return 'default';
    }
};
